/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetReturnsList } from "../../../../hooks/api/queries/useInventory";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";

const useReturns = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const [isReturn, setIsReturn] = useState(false);
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
  } = useUrlSearch();

  const [startDate] = useState(search.get("start_date"));
  const [endDate] = useState(search.get("end_date"));

  const {
    data: returns,
    isLoading: isLoadingReturns,
    refetch: handleFetchReturns,
  } = useGetReturnsList({ queries });

  const filterReturnStatus = (value) => {
    filterByKey("return_status", value);
  };

  useEffect(() => {
    if (!search.get("has_returns") || !search.get("order_source")) {
      search.set("order_source", search.get("order_source") || "INTERNAL");
      search.set("has_returns", search.get("has_returns") || true);
      setSearch(search, { replace: true });
    }
  }, []);

  return {
    storeList,
    isLoadingReturns,
    returns: returns?.data || [],
    metaDetails: returns?.meta || {},
    isReturn,
    search,
    setIsReturn,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    handleFetchReturns,
    filterReturnStatus,
    startDate,
    endDate,
  };
};
export default useReturns;
